'use client'

import { useEffect } from 'react'

import {
  handleChunkLoadError,
  isChunkLoadError,
} from '@maestro/commerce-blocks/utils/chunk-error.utils'

export function ChunkErrorHandler() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      if (isChunkLoadError(event.error)) {
        event.preventDefault()
        handleChunkLoadError()
      }
    }

    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (isChunkLoadError(event.reason)) {
        event.preventDefault()
        handleChunkLoadError()
      }
    }

    window.addEventListener('error', onError)
    window.addEventListener('unhandledrejection', onUnhandledRejection)

    return () => {
      window.removeEventListener('error', onError)
      window.removeEventListener('unhandledrejection', onUnhandledRejection)
    }
  }, [])

  return null
}
